var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-input m-calendar-input",class:{
    'm-input_large': _vm.large,
    'm-input_small': _vm.small
  }},[_c('DateInput',{staticClass:"input__field m-input__field",attrs:{"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":_vm.onDateChange,"click":function($event){return _vm.$emit('click')}}}),_vm._v(" "),_c('MIcon',{staticClass:"m-input__icon",attrs:{"icon":_vm.iconCalendar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }